


















































import {
  OverallDryingRating,
  OverallDryingRatingAttribute,
  OverallDryingRatingAttributeNames,
} from "@/data/models/OverallDryingRating";
import { COLOR_NOT_SELECTED_QUALITY_RATING, COLOR_SELECTED_QUALITY_RATING } from "@/utils/colors";
import { themedRatingCell } from "@/utils/Theme";
import { Vue, Component, Model, Prop } from "vue-property-decorator";

@Component
export default class RateOverallDryingQualityComponent extends Vue {
  @Prop({ default: true })
  editEnabled!: boolean;

  @Model("overallDryingRating")
  overallDryingRating!: OverallDryingRating;
  overallDryingRatingAttributeNames = OverallDryingRatingAttributeNames;

  ratingOptions = ["veryBad", "bad", "good", "veryGood"];
  ratingOptionsForDryingDuration = ["tooShort", "short", "good", "long", "tooLong"];

  get headerRow() {
    return this.$t("rateDrying.qualityOverall.title").toString();
  }

  getRatingFromColumnIndex(columnIndex: number, ratingOptionsLength: number) {
    //Ignore label column
    const adjustedIndex = columnIndex - 1;
    const ratingOffset = Math.floor(ratingOptionsLength / 2);

    const isNumberOfRatingOptionsEven = (ratingOptionsLength % 2) === 0

    if (isNumberOfRatingOptionsEven) {
      if (adjustedIndex - ratingOffset >= 0) {
        // Ignore neutral rating
        return adjustedIndex - ratingOffset + 1;
      }
    }

    return adjustedIndex - ratingOffset;
  }

  /** The cell's fill and label class for the active theme (see `themedRatingCell`). */
  ratingCell(lightColor: string) {
    return themedRatingCell(lightColor);
  }

  getRatingColor(
    columnIndex: number,
    ratingAttribute: OverallDryingRatingAttribute
  ) {
    const rating = ratingAttribute === "dryingDuration"
      ? this.getRatingFromColumnIndex(columnIndex, this.ratingOptionsForDryingDuration.length)
      : this.getRatingFromColumnIndex(columnIndex, this.ratingOptions.length);
    const matchesCurrentRating =
      rating === this.overallDryingRating[ratingAttribute];

    if (matchesCurrentRating && (ratingAttribute === "dryingDuration" || rating !== 0)) {
      if (rating !== 0 || ratingAttribute === "dryingDuration") {
        return COLOR_SELECTED_QUALITY_RATING;
      }
      else {
        return COLOR_NOT_SELECTED_QUALITY_RATING;
      }
    } else {
      return COLOR_NOT_SELECTED_QUALITY_RATING;
    }
  }

  toggleOverallDryingRating(
    columnIndex: number,
    ratingAttribute: OverallDryingRatingAttribute
  ) {
    const currentRating = this.overallDryingRating[ratingAttribute];
    const newRating = ratingAttribute === "dryingDuration"
      ? this.getRatingFromColumnIndex(columnIndex, this.ratingOptionsForDryingDuration.length)
      : this.getRatingFromColumnIndex(columnIndex, this.ratingOptions.length);
    const update = {
      ...this.overallDryingRating,
      [ratingAttribute]:
        currentRating === newRating
          ? null
          : ratingAttribute === "dryingDuration"
            ? this.getRatingFromColumnIndex(columnIndex, this.ratingOptionsForDryingDuration.length)
            : this.getRatingFromColumnIndex(columnIndex, this.ratingOptions.length)
    };

    this.$emit("overallDryingRating", update);
  }

  getOverallDryingRatingRow(rating: OverallDryingRatingAttribute) {
    return rating === "dryingDuration" 
      ? [
          this.$t(`rateDrying.qualityOverall.${rating}`),
          ...this.ratingOptionsForDryingDuration.map((res) =>
            this.$t(`rateDrying.qualityDrying.${res}`)
          ),
        ]
      : [
          this.$t(`rateDrying.qualityOverall.${rating}`),
          ...this.ratingOptions.map((res) =>
            this.$t(`rateDrying.qualityDrying.${res}`)
          ),
        ];
  }

  canCellBeClicked(index: number) {
    return index > 0;
  }
}
